import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Wordmark } from "../components/Wordmark";
import { ChangePasswordForm } from "../components/ChangePasswordForm";

export default function ForceChangePassword() {
  const { refreshMe } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F7] p-6">
      <div className="w-full max-w-md bg-white border border-[#E5E5EA] rounded-2xl p-8 fade-up" data-testid="force-change-password">
        <Wordmark className="text-2xl" />
        <h1 className="text-2xl font-extrabold tracking-tight mt-6">Set your password</h1>
        <p className="text-sm text-[#6E6E73] mt-1 mb-6">You signed in with a temporary password. Please choose a new one to continue.</p>
        <ChangePasswordForm onDone={async () => { await refreshMe(); navigate("/"); }} />
      </div>
    </div>
  );
}
